import {
	applyMiddleware,
	combineReducers,
	compose,
	createStore,
	Middleware
} from "redux";
import ReduxLogger from "redux-logger";
import ReduxThunk from "redux-thunk";

// reducers
import { cache, ZomentumWindow } from "@/Contracts";
import { hydrateFieldsMiddleware } from "@/Utils";
import AssessmentsReducer from "./Reducers/Assessments";
import BannerNotificationReducer from "./Reducers/BannerNotification";
import BulkImportReducer from "./Reducers/BulkImport";
import ClientsReducer from "./Reducers/Clients";
import { ContactsReducer } from "./Reducers/Contacts";
import { DocumentApprovalReducer } from "./Reducers/DocumentApproval";
import DocumentsReducer from "./Reducers/Documents";
import EmailTemplatesReducer from "./Reducers/EmailTemplates";
import LoginReducer from "./Reducers/Login";
import MarketplaceReducer from "./Reducers/Marketplace";
import OpportunitiesReducer from "./Reducers/Opportunity";
import EmailThreadReducer from "./Reducers/Others/EmailThread";
import { GlobalSearchReducer } from "./Reducers/Others/GlobalSearch";
import MergeTagsReducer from "./Reducers/Others/MergeTags";
import NotificationFeedReducer from "./Reducers/Others/NotificationFeed";
import RecentActivityFeedReducer from "./Reducers/Others/RecentActivityFeed";
import PipelinesReducer from "./Reducers/Pipelines";
import ProductsReducer from "./Reducers/Products";
import QbrReducer from "./Reducers/QBR";
import ReportsReducer from "./Reducers/Reports/Reports.reducer";
import SettingsReducer from "./Reducers/Settings";
import TagReducer from "./Reducers/Tags";
import TemplatesReducer from "./Reducers/Templates";
import UIConfigReducer from "./Reducers/UI";
import UserReducer from "./Reducers/User";
import { CustomFieldsReducer } from "./Reducers/CustomFields";
import AnnouncementReducer from "./Reducers/Announcement";
import CopilotReducer from "./Reducers/Copilot";

declare let window: ZomentumWindow;

const middleWare: Array<Middleware> = [ReduxThunk, hydrateFieldsMiddleware];
let composeEnhancers = compose;

if (
	process.env.REACT_APP_NODE_ENV !== "production" &&
	process.env.NODE_ENV !== "test"
) {
	if (JSON.parse(process.env.REACT_APP_ENABLE_REDUX_LOGGER || "true")) {
		middleWare.push(ReduxLogger);
	}
	const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
	if (devToolsExtension && typeof devToolsExtension === "function") {
		composeEnhancers = devToolsExtension || compose;
	}
}

export const appliedMiddleware = composeEnhancers(
	applyMiddleware(...middleWare)
);

export const reducers = combineReducers({
	login: LoginReducer,
	documents: DocumentsReducer,
	opportunities: OpportunitiesReducer,
	products: ProductsReducer,
	clients: ClientsReducer,
	contacts: ContactsReducer,
	user: UserReducer,
	settings: SettingsReducer,
	recentActivityFeed: RecentActivityFeedReducer,
	emailThread: EmailThreadReducer,
	notificationFeed: NotificationFeedReducer,
	templates: TemplatesReducer,
	bannerNotification: BannerNotificationReducer,
	bulkImport: BulkImportReducer,
	assessments: AssessmentsReducer,
	pipelines: PipelinesReducer,
	globalSearch: GlobalSearchReducer,
	reports: ReportsReducer,
	emailTemplates: EmailTemplatesReducer,
	documentApprovals: DocumentApprovalReducer,
	uiConfig: UIConfigReducer,
	qbr: QbrReducer,
	marketplace: MarketplaceReducer,
	mergeTags: MergeTagsReducer,
	customFields: CustomFieldsReducer,
	announcement: AnnouncementReducer,
	copilot: CopilotReducer,
	tags: TagReducer
});

const store = createStore(reducers, appliedMiddleware);

store.subscribe(() => {
	const state = store.getState();

	cache.updateReduxKey("userData", state.user.userData);
	cache.updateReduxKey(
		"configurationSettings",
		state.user.configurationSettings
	);
	cache.updateReduxKey("companyUserList", state.user.companyUserList);
	cache.updateReduxKey("userCompany", state.user.userCompany);
});

export default store;
